import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getShipmentSpotBidDataInProgress } from '../../../../../../redux/shipment/ShipmentActions';
import { routeFileSelector } from '../../../../../../utilz/i18n';
import EmptyRecords from '../../../../../components/Common/EmptyRecords';
import ContentSpinner from '../../../../../components/Spinners/ContentSpinner';
import RateShopDetailsCard from '../RateShopDetails/RateShopDetailsCard';

const CloseSportBidForm = () => {
  const dispatch = useDispatch();
  const { shipmentDetails, spotBidData } = useSelector((state) => state.shipment);
  const [selectedRateShop, setSelectedRateShop] = useState(false);
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  useEffect(() => {
    fetchSpotBidData();
  }, []);

  const fetchSpotBidData = () => {
    const payload = { ShipmentKey: shipmentDetails?.data?.shipmentKey };
    dispatch(getShipmentSpotBidDataInProgress(payload));
  };
  return (
    <div className="h-100 d-flex flex-direction-column">
      <div className="flex-1 flex-1 custom-scroll-bar">
        {spotBidData.progressing ? (
          <ContentSpinner size="large" className="p-50" />
        ) : (
          <>
            {spotBidData?.data?.length > 0 ? (
              <>
                {spotBidData?.data?.map((row, index) => (
                  <RateShopDetailsCard
                    // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
                    key={index}
                    rateShopDetails={row}
                    handleRateShopSelection={(val) => setSelectedRateShop(val)}
                    index={index}
                    value={selectedRateShop === index ? selectedRateShop : false}
                  />
                ))}
              </>
            ) : (
              <EmptyRecords descriptionTwo={t('translation:shipmentAdd.spotBid.submitSpotBidToCarriers')} />
            )}
          </>
        )}
      </div>
    </div>
  );
};
export default CloseSportBidForm;
